import React, { useState } from "react";
import * as Yup from "yup";
import { InputWithLabel } from "../../../components/micro/input";
import { Form, Formik } from "formik";
import { useNavigate } from "react-router-dom";
import ConfirmationModel from "../../../components/common/ConfirmationModel";
import { createCompany, getCompanies } from "../../../redux/companies/slice";
import { useDispatch } from "react-redux";
import {
  createGeneralSetting,
  getGeneralSettingList,
} from "../../../redux/masterSetting/slice";

const EditCompanyModal = ({
  onClose,
  company,
  companyData,
  isType,
  modalType,
  selectedData,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [formValues, setFormValues] = useState(null);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    const id = company?.id || companyData?.id;
    const payload = {
      id,
      name: values?.companyName,
      email: values?.email,
      phone: values?.phone,
      uen: values?.companyUEN,
      address: values?.address,
      postal_code: values?.postalcode,
      remarks: "-",
    };
    const generalSettingpayload = {
      company_name: values?.companyName,
      email: values?.email,
      mobile: values?.phone,
      uen: values?.companyUEN,
      address: values?.address,
      postal_code: values?.postalcode,
    };

    const action = selectedData?.id
      ? createGeneralSetting({ id: selectedData?.id, ...generalSettingpayload })
      : createGeneralSetting(generalSettingpayload);

    try {
      if (modalType === "generalSetting") {
        const res = await dispatch(action);
        if (res.type === "createGeneralSetting/fulfilled") {
          dispatch(getGeneralSettingList());
        }
      } else {
        const res = await dispatch(createCompany(payload));
        if (res.type === "createCompany/fulfilled") {
          dispatch(getCompanies({ id: company?.id }));
          navigate("/company-information", {
            state: { company: { ...company, ...values } },
          });
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setIsLoading(false);
      setShowConfirmationModal(false);
      onClose();
    }
  };

  const handleEditClick = () => {
    setShowConfirmationModal(true);
  };

  return (
    <>
      <div className="model" onClick={onClose}>
        <div
          className="bg-white items-center justify-center drop-shadow-lg rounded-lg w-full max-w-3xl py-8 px-6 mx-auto relative"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <h4 className="font-Montserrat text-[34px] font-normal pb-3">
            {isType === "add" ? "Add Company Details" : "Edit Company Details"}
          </h4>
          <Formik
            enableReinitialize={true}
            initialValues={
              modalType === "generalSetting"
                ? {
                    companyName: selectedData?.company_name || "",
                    companyUEN: selectedData?.uen || "",
                    email: selectedData?.email || "",
                    phone: selectedData?.mobile || "",
                    address: selectedData?.address || "",
                    postalcode: selectedData?.postal_code || "",
                  }
                : {
                    companyName: company?.name || companyData?.name || "",
                    companyUEN: company?.uen || companyData?.uen || "",
                    email: company?.email || companyData?.email || "",
                    phone: company?.phone || companyData?.phone || "",
                    address: company?.address || companyData?.address || "",
                    postalcode:
                      company?.postal_code || companyData?.postal_code || "",
                  }
            }
            validationSchema={Yup.object().shape({
              companyName: Yup.string()
                .trim()
                .min(3, "Name must be at least 3 characters")
                .required("Please enter name"),
              email: Yup.string()
                .trim()
                .email("Invalid email format")
                .required("Please enter email"),
              phone: Yup.string()
                .trim()
                .required("Please enter mobile number")
                .min(8, "Mobile is too short - should be 8 chars minimum.")
                .max(15, "Mobile is too long - should be 15 chars maximum.")
                .matches(/^\d+$/, "Mobile number must be numeric"),
              address: Yup.string()
                .trim()
                .min(3, "Address must be at least 3 characters")
                .required("Please enter address"),
              postalcode: Yup.string()
                .trim()
                .required("Please enter postal code")
                .length(6, "Postal code must be exactly 6 digits")
                .matches(/^\d+$/, "Postal code must be numeric"),
            })}
            onSubmit={(values) => {
              setFormValues(values);
              handleEditClick();
            }}
          >
            {({ values, errors, touched, handleBlur, handleChange }) => (
              <Form>
                <div className="grid grid-cols-2 gap-6 mb-4 mt-3">
                  {/* Name */}
                  <InputWithLabel
                    className={`${
                      errors.companyName && touched.companyName
                        ? `border border-red`
                        : `border border-borderTheme/80 focus-within:border-themeBtn `
                    }  transition duration-300 ease-in-out w-full text-black border hover:border-themeBtn`}
                    idFromName="companyName"
                    label="Company Name*"
                    type="text"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.companyName}
                    errors={errors.companyName && touched.companyName}
                    errorsText={errors.companyName}
                  />
                  {/* company UEN */}
                  <InputWithLabel
                    className={`${
                      errors.companyUEN && touched.companyUEN
                        ? `border border-red`
                        : `border border-borderTheme/80 focus-within:border-themeBtn `
                    }  transition duration-300 ease-in-out`}
                    idFromName="companyUEN"
                    label="UEN"
                    type="number"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onFocus={(e) =>
                      e.target.addEventListener(
                        "wheel",
                        function (e) {
                          e.preventDefault();
                        },
                        { passive: false }
                      )
                    }
                    value={values.companyUEN}
                  />

                  {/* Phone */}
                  <InputWithLabel
                    className={`${
                      errors.phone && touched.phone
                        ? `border border-red`
                        : `border border-borderTheme/80 focus-within:border-themeBtn `
                    }  transition duration-300 ease-in-out`}
                    idFromName="phone"
                    label="Mobile Number*"
                    type={"number"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.phone}
                    errors={errors.phone && touched.phone}
                    errorsText={errors.phone}
                    onFocus={(e) =>
                      e.target.addEventListener(
                        "wheel",
                        function (e) {
                          e.preventDefault();
                        },
                        { passive: false }
                      )
                    }
                  />
                  {/* Email */}
                  <InputWithLabel
                    className={`${
                      errors.email && touched.email
                        ? `border border-red`
                        : `border border-borderTheme/80 focus-within:border-themeBtn `
                    }  transition duration-300 ease-in-out`}
                    idFromName="email"
                    label="Email*"
                    type="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    errors={errors.email && touched.email}
                    errorsText={errors.email}
                  />
                  {/* Address */}
                  <InputWithLabel
                    className={`${
                      errors.address && touched.address
                        ? `border border-red`
                        : `border border-borderTheme/80 focus-within:border-themeBtn `
                    }  transition duration-300 ease-in-out`}
                    idFromName="address"
                    label="Address*"
                    type="address"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.address}
                    errors={errors.address && touched.address}
                    errorsText={errors.address}
                  />
                  {/* Postal Code */}
                  <InputWithLabel
                    className={`${
                      errors.postalcode && touched.postalcode
                        ? `border border-red`
                        : `border border-borderTheme/80 focus-within:border-themeBtn `
                    }  transition duration-300 ease-in-out`}
                    idFromName="postalcode"
                    label="Postal Code*"
                    type="number"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.postalcode}
                    errors={errors.postalcode && touched.postalcode}
                    errorsText={errors.postalcode}
                    onFocus={(e) =>
                      e.target.addEventListener(
                        "wheel",
                        function (e) {
                          e.preventDefault();
                        },
                        { passive: false }
                      )
                    }
                  />
                </div>

                {/* Submit button */}
                <div className="flex justify-end gap-3 mt-6 w-full">
                  <button
                    onClick={onClose}
                    type="button"
                    className=" text-themeBtn w-full flex items-center uppercase font-Montserrat justify-center px-6 py-1.5 rounded border border-themeBtn"
                  >
                    <span>Cancel</span>
                  </button>
                  <button
                    type="submit"
                    className="flex items-center w-full justify-center px-6 py-1.5 rounded font-Montserrat uppercase border-2 border-themeBtn  text-white bg-themeBtn"
                  >
                    <span>Confirm</span>
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        {showConfirmationModal && (
          <div>
            <ConfirmationModel
              confirmText={"Edit"}
              onClose={() => setShowConfirmationModal(false)}
              onConfirm={() => handleSubmit(formValues)}
              isLoading={isLoading}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default EditCompanyModal;
